import React from 'react';

const CheckoutMessage = ({email, event, isInValidTimer}) => {
  if(event === 'unreserve') {
    return (
      <div>
        <p>
          <strong><i className="fa fa-lock" />&nbsp;Are you sure you want to remove this spot?</strong><br />
          Once you remove this spot, it will be open for someone else to select
        </p>
      </div>
    );
  }

  if(isInValidTimer) {
    return (
      <div>
        <p>
          <strong><i className="fa fa-warning color-danger" />&nbsp;Time is up</strong><br />
        </p>
        <p>
          You did not confirm this spot in the allotted time and it has been opened back up for reservation.
        </p>
      </div>
    );
  }

  return (
    <div>
      <p>

      <strong><i className="fa fa-lock" />&nbsp;Payment information</strong><br />
        You will be charged at a later date TBD by the event organizer with the card you have on file with MSR
      </p>

      {/*<p>*/}
        {/*<strong>Confirmation email will be sent to</strong><br /> {email}*/}
      {/*</p>*/}
    </div>
  );

};

export default CheckoutMessage;



// WEBPACK FOOTER //
// ./src/components/checkout/CheckoutMessage.js